
import { newInstance, autoinject, singleton, bindable, bindingMode, observable } from 'aurelia-framework';
import { TaskActionService } from '../TaskActionService';
import { UiActionButton } from '../UiActionButton';
import { PageMessageService } from '../../../services/page-message-service';
import { BusyService } from '../../../services/busy-service';
import { DialogService } from 'aurelia-dialog';
import { WebApiService } from '../../../services/web-api-service';
import { SimpleDialog } from '../../dialogs/simple-dialog';
import { UpdateUserDialog } from '../../dialogs/update-user-dialog';
import { Guid } from 'guid-typescript';
import { SecurityService } from '../../../services/security-service';
import { CmpTaskDto } from '../../../data/typegen/dtos/cmp-task-dto';
import { TaskState } from '../../../data/enums/taskState';
import { UpdateUserModel } from '../../../data/typegen/dtos/update-user-model';
import { ProcessNewUserTaskDto } from '../../../data/typegen/dtos/process-new-user-task-dto';
import { CmpTaskCommentInsertDto } from '../../../data/dtos/cmp-task-comment-insert-dto';
import { ValidationController } from 'aurelia-validation';
import { NewUserRequestVariablesDto } from '../../../data/typegen/dtos/new-user-request-variables-dto';
import { DoUiActionDto } from '../../../data/typegen/dtos/do-ui-action-dto';
import { CmpTaskBaseDto } from '../../../data/typegen/dtos/cmp-task-base-dto';
import { NewUserRequestTaskDto } from '../../../data/typegen/dtos/new-user-request-task-dto';
import { DoUiActionClientHandlerResult } from '../../../data/dtos/do-ui-action-client-handler-result';
import { RequestDto } from '../../../data/typegen/dtos/request-dto';
import { ComposeEmailDialog } from '../../dialogs/compose-email-dialog/compose-email-dialog';
import { FulfillmentWidget, IFulfillmentWidget } from '../new-user-request/new-user-request-fulfillment';
import { Globals } from '../../../models/globals';


@autoinject()
export class InsuranceRenewalFulfillment extends FulfillmentWidget implements IFulfillmentWidget {

    public showCloseAction: boolean = true;
    public entityTypes: { id: string; description: string; }[] = new Globals().getEntityTypes();
    public showAdditionalRequestorFields: boolean = false;


    async validate(controller: ValidationController, obj: any) {
        return true;
    }

    private rejectAction: UiActionButton
    private approveAction: UiActionButton

    public get isTrucksCarrier(): boolean {
        return this.task && (this.task.variables.EntityType == "TRUCKS" || this.task.variables.EntityType == 'TRANSLOADER/TRUCKS');
    }

    public isComponentReadOnly = false;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) readonly: boolean;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) task: CmpTaskDto;
    taskChanged() {
        this.initUi();
    }

    constructor(
        private taskActionService: TaskActionService,
        private busyService: BusyService,
        private securityService: SecurityService,
        private msg: PageMessageService,
        private dialogService: DialogService,
        private api: WebApiService,
        element: Element
    ) {
        super(element);

    }


    public myDivisions = [];

    loadCarrierMills() {
        this.busyService.on();
        return this.api.get("Divisions", "GetDivisions")
            .then((result) => {
                this.myDivisions = JSON.parse(result.response);
                this.busyService.off();
            });
    }

    async afterActionSubmit(uiAction: string, error?: any): Promise<boolean> {
        // return true to reload the data
        return true;
    }

    public async initUi() {

        var isEditor = this.securityService.hasRole("Edit");
        this.isComponentReadOnly = this.readonly || !this.task.active || !isEditor;
        this.showAdditionalRequestorFields = !!this.task.variables.DateNeeded;

    }


    public async doAction(action: DoUiActionDto<CmpTaskBaseDto>): Promise<DoUiActionClientHandlerResult> {

        return DoUiActionClientHandlerResult.default;
    }

    async attached() {
        await this.initUi();
        await this.loadCarrierMills();
        await this.fireOnreadyEvent();
    }

}